import {ApiNames} from '@shared-types';

import {ApiErrorModel} from './api-error.model';

export type APIErrorsStruct = {
	errors: {
		[key in ApiNames]: {
			[errorMessage in string]: {
				id?: string;
				userMessage: string;
				catchError: boolean;
				onError?: null | {navTo: string};
			};
		};
	};
};

export interface ApiErrorObject {
	errorMessage: string;
	userMessage: string;
	statusCode?: number;
	details?: any;
	apiName: string;
	catchError?: boolean;
	id?: string | number; // Add the id property
	onError?: {
		// Add the onError property
		navTo?: string;
		// Add any other properties needed in onError
	};
}

export function isApiErrorObject(error: unknown): error is ApiErrorObject {
	return typeof error === 'object' && error !== null && 'errorMessage' in error && typeof (error as ApiErrorObject).errorMessage === 'string';
}

export type ApiError = Error & {
	apiErrorObject: ApiErrorObject;
};

export function isApiError(error: unknown): error is ApiErrorModel {
	return (error as ApiErrorModel)?.apiErrorObject !== undefined && error instanceof Error;
}
